import React, {FC} from "react";
import styled from "styled-components";
import {ProfileBeaconDropdown} from "../Shared/ProfileBeaconComponents";

interface Props {
    name?: string;
    label?: string;
    value?: string;
    id?: string;
    options?: any;
    hideDropdownLabel?: boolean;
    onInput?: (event: any) => void;
    onClick?: (event: any) => void;
    onBlur?: (event: any) => void;
}

const StyledDropdown = styled(ProfileBeaconDropdown)`
  width: ${({name}) => name === "paycheckFrequency" ? "170px": (name === "monthlyPerformance" || name === "dailyPrices") ? "400px": "217px"};
  @media(max-width: 640px){
    width: ${({name}) => (name === "monthlyPerformance" || name === "dailyPrices") ? "100%" : name === "paycheckFrequency" ? "140px" : ""};
  };
  --beacon-form-label-font-size: 0px;
  display: ${({hideDropdownLabel}) => hideDropdownLabel && "flex"};
`;
const Dropdown: FC<Props> = ({
                                 name,
                                 id,
                                 value,
                                 label,
                                 options,
                                 hideDropdownLabel,
                                 onInput,
                                 onClick,
                                 onBlur,
                                 disabled}) => {
    return (
        <StyledDropdown label={label} disabled={disabled} hideDropdownLabel={hideDropdownLabel} id={id} name={name} onBlur={onBlur} onInput={onInput} onClick={onClick} value={value}>
            {options && options.map( (item : any) => {
                return (
                        <>
                            <option value={item.value}>{item.name}</option>
                        </>
                )
            })
            }
        </StyledDropdown>
    )
}
export default Dropdown;